import axios from "axios";

const base = "/defense-hod-assignments/programme-types";

const AffiliationDefenseHodAssignments = {
  get: async (programmeTypeId) => axios.get(`${base}/${programmeTypeId}`),

  getForLecturer: async (lecturerId) => axios.get(`${base}/lecturers/${lecturerId}`),

  assign: async (programmeTypeId, lecturerId) => axios.put(
    `${base}/${programmeTypeId}`,
    { lecturerId },
  ),

  remove: async (programmeTypeId) => axios.delete(`${base}/${programmeTypeId}`),
};

export default AffiliationDefenseHodAssignments;
